module.exports = __webpack_public_path__ + "static/media/02.5501e3c1.png";